import { DELETE_ALERT, ADD_ALERT } from '../actions/alerts.action';
import { RESET_STATE } from '../actions/common.actions';

export const alerts = (state = [], action) => {
  switch (action.type) {
    case ADD_ALERT:
      return [ ...state,  action.payload ];

    case DELETE_ALERT:
      return state.slice(0, state.length - 1);

    case RESET_STATE:
      return [];

    default:
      return state;
  }
};
